/* global integrationConfigured syncEnabled action toggleUrl model syncNowUrl syncTypes */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ToggleSync from './ToggleSync';

export default function ToggleActualCostsSync(props) {
    const types = [
        {
            name: 'Import Cash Transactions',
            key: 'cash_transactions',
            description: $t(
                'This option will import transactions on a cash basis. This means that payments and receipts will be ' +
                    'imported when they are processed as bank transactions. Transactions will more closely reflect cashflow, however, ' +
                    'due to limitations with Xero, there may be more manual reconciliation required.',
            ),
        },
        {
            name: 'Import Posted Items',
            key: 'posted_invoices',
            description: $t(
                'This option will import transactions based on invoices posted, as well as applicable transactions such as expense and payroll payments.',
            ),
        },
    ];

    const getTypes = () => {
        const res = [];
        const sTypes = props.syncTypes ?? [];

        types.forEach((type) => {
            if (sTypes.includes(type.key)) {
                res.push(type);
            }
        });

        return res;
    };

    return (
        <ToggleSync
            integrationConfigured={props.integrationConfigured}
            syncEnabled={props.syncEnabled}
            canRemoveData={!!props.syncEnabled && props.syncEnabled}
            removeHeader={$t('Remove Imported Actuals')}
            action={props.action}
            toggleUrl={props.toggleUrl}
            model={props.model}
            modelName={$t('Actual Costs')}
            syncNowUrl={props.syncNowUrl}
            toggleCallback={() => {
                props.toggleCallback();
            }}
            toggleModalId={'enable-actual-costs-sync'}
            importNowMessage={$t('Import {{model}} now', { model: $t('Actual Costs') })}
            types={getTypes()}
            defaultType={types[0].key}
        />
    );
}

if (document.getElementById('ToggleActualCostsSync')) {
    var rootEl = document.getElementById('ToggleActualCostsSync');
    ReactDOM.render(
        <App>
            <ToggleActualCostsSync
                integrationConfigured={integrationConfigured}
                syncEnabled={syncEnabled}
                action={action}
                toggleUrl={toggleUrl}
                model={model}
                syncNowUrl={syncNowUrl}
                toggleCallback={() => {
                    window.location.reload();
                }}
                syncTypes={syncTypes}
            />
        </App>,
        rootEl,
    );
}
